import request from '@/utils/request'

export function epms1020xls(param) {
  const data = param
  return request({
    url: `/common/xls/epms1020xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms1020xlsRes', res)

    const filename = `BOM.xls`
    xlsDownload(filename, res)
  })
}

export function epms7010xls(param) {
  const data = param
  return request({
    url: `/common/xls/epms7010xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms7010xlsRes', res)

    const filename = `(${data.quotNo})Pipe_List.xls`
    xlsDownload(filename, res)
  })
}

export function epms7030xls(param) {
  const data = param
  return request({
    url: `/common/xls/epms7030xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms7030xlsRes', res)

    const filename = `${data.quotNo}.xls`
    xlsDownload(filename, res)
  })
}

export function xlsDownload(filename, res) {
  const binaryString = window.atob(res.body)
  const binaryLen = binaryString.length
  let bytes = new Uint8Array(binaryLen)
  
  for (let i = 0; i < binaryLen; i++) {
    let ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  
  const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
  const blobURL = URL.createObjectURL(blob)

  const link = document.createElement('a');
  link.href = blobURL;
  link.download = filename;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

export function saveAsExcel(url, param) {
  const data = param
  return request({
    url,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}